import { useCallback, useEffect } from 'react';
import { editPassword } from '@actions/profile';
import useForm from '@components/form/hooks/useForm';
import {
    getProfileEditPasswordSuccess,
    getProfileIsPosting,
    getProfilePostError,
} from '@selectors/profile';
import { useDispatch, useSelector } from 'react-redux';
import usePrevious from 'lib/src/hooks/usePrevious';

const useEditPassword = (closeModal: () => void) => {
    const dispatch = useDispatch();
    const isPosting = useSelector(getProfileIsPosting);
    const postError = useSelector(getProfilePostError);
    const editPasswordSuccess = useSelector(getProfileEditPasswordSuccess);

    const prevEditPasswordSuccess = usePrevious(editPasswordSuccess);

    const [formState, handleChange] = useForm({
        currentPassword: '',
        password: '',
        confirmPassword: '',
    });

    const handleSubmit = useCallback(() => {
        dispatch(editPassword(formState));
    }, [dispatch, formState]);

    useEffect(() => {
        if (!prevEditPasswordSuccess && editPasswordSuccess) {
            closeModal();
        }
    }, [editPasswordSuccess, prevEditPasswordSuccess, closeModal]);

    return { isPosting, postError, editPasswordSuccess, formState, handleChange, handleSubmit };
};

export default useEditPassword;
